import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { money } from "@/lib/api";
import { Minus, Plus, Trash2 } from "lucide-react";

export default function CartPage() {
  const { items, totals, update, remove } = useCart();
  return (
    <div className="bls-container py-12">
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter">Your cart</h1>
      <p className="mt-2 text-black/55">{items.length} item{items.length !== 1 ? "s" : ""}</p>

      {items.length === 0 ? (
        <div className="mt-16 text-center py-20 bg-white rounded-2xl border border-black/5">
          <p className="font-display text-2xl font-bold">Your cart is empty</p>
          <Link to="/products" className="mt-6 inline-flex bls-btn-primary">Continue shopping</Link>
        </div>
      ) : (
        <div className="mt-10 grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2 bg-white rounded-2xl border border-black/5 divide-y divide-black/5">
            {items.map((it) => (
              <div key={it.product_id} className="p-6 flex gap-4 items-center" data-testid={`cart-page-item-${it.product_id}`}>
                <div className="bls-thumb w-24 h-24 flex-shrink-0">
                  {it.image && <img src={it.image} alt={it.name} className="w-full h-full object-cover" />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold">{it.name}</p>
                  <p className="text-sm text-black/55 mt-1">{money(it.price, totals.currency_symbol)}</p>
                  <div className="mt-3 inline-flex items-center border border-black/10 rounded-full">
                    <button className="w-8 h-8 inline-flex items-center justify-center" onClick={() => update(it.product_id, it.quantity - 1)}>
                      <Minus className="w-3 h-3" />
                    </button>
                    <span className="w-8 text-center text-sm font-medium">{it.quantity}</span>
                    <button className="w-8 h-8 inline-flex items-center justify-center" onClick={() => update(it.product_id, it.quantity + 1)}>
                      <Plus className="w-3 h-3" />
                    </button>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-display text-lg font-bold">{money(it.price * it.quantity, totals.currency_symbol)}</p>
                  <button onClick={() => remove(it.product_id)} className="mt-2 text-xs text-black/40 hover:text-red-500 inline-flex items-center gap-1">
                    <Trash2 className="w-3 h-3" /> Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          <aside className="bg-white rounded-2xl border border-black/5 p-6 h-fit sticky top-24">
            <h2 className="font-display font-bold text-xl">Order summary</h2>
            <div className="mt-4 space-y-3 text-sm">
              <div className="flex justify-between"><span className="text-black/60">Subtotal</span><span>{money(totals.subtotal, totals.currency_symbol)}</span></div>
              <div className="flex justify-between"><span className="text-black/60">Shipping</span><span>{totals.shipping > 0 ? money(totals.shipping, totals.currency_symbol) : "Free"}</span></div>
              {totals.tax > 0 && <div className="flex justify-between"><span className="text-black/60">Tax</span><span>{money(totals.tax, totals.currency_symbol)}</span></div>}
              <div className="border-t border-black/5 pt-3 flex justify-between items-baseline">
                <span className="font-display font-bold">Total</span>
                <span className="font-display text-2xl font-bold">{money(totals.total, totals.currency_symbol)}</span>
              </div>
            </div>
            <Link to="/checkout" className="bls-btn-primary w-full mt-6" data-testid="cart-page-checkout">Checkout →</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
